import React, { useEffect, useState, useMemo } from "react";
import { usePrevious } from "../utilities/hooks";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useMediaQuery } from "react-responsive";
import { get } from "../actions/app";
import { applyHash as modifyFilters } from "../actions/filters";
import { applyHash as modifyParts } from "../actions/parts";
import { applyHash as modifyQS } from "../actions/quick-search";
import { determineFilters } from "../utilities/filters";
import BreakPoints from "../constants/breakpoints";
import * as API from "../constants/api";
import Pagination from "../components/Pagination";
import PartPopup from "../components/PartPopup";
import Table from "../components/Table2";
import Title from "../components/Title";
import BreadCrumb from "../components/BreadCrumb";
import List from "../components/Table2/List";
import FeatureLayout from "../components/FeatureLayout";
import FeatureMobileLayout from "../components/FeatureMobileLayout";
import ManageParametersModal from "../components/ManageParametersModal";
import ManageTools from "../components/ManageTools";
import QualtricsFeedbackForm from "../components/QualtricsFeedbackForm";
import PageLoadingIcon from "../img/icons/loader-4-line.svg";
import PromoBanner from "../components/PromoBanner";
import "./style.css";

/**
 * @name Layout
 * @function
 * @description Displays the layout for the logged in state of the app
 * @returns {JSX}
 * @param {*} props
 */
function Layout(props) {
  const [params, setParams] = useState(null),
    [mod, setMod] = useState(null),
    prevMod = usePrevious(mod),
    isDesktop = useMediaQuery({ minWidth: BreakPoints.laptop.min }),
    isTablet = useMediaQuery({ minWidth: BreakPoints.tablet.min, maxWidth: BreakPoints.tablet.max }),
    isMobile = useMediaQuery({ maxWidth: BreakPoints.mobile.max }),
    classNames = useMemo(() => {
      const ary = [ 'pst' ];
      if( isDesktop ) ary.push( 'desktop' );
      if( isTablet ) ary.push( 'tablet' );
      if( isMobile ) ary.push( 'mobile' );
      return ary.join( ' ' );
    }, [ isDesktop, isTablet, isMobile ]),
    checkMod = (val1, val2) => {
      let a = JSON.stringify(val1),
        b = JSON.stringify(val2),
        different = a !== b;
      return different;
    };

  useEffect(() => {
    if (!params && props.parameters && props.parameters.length > 0) {
      setMod(determineFilters(props.parameters));
      setParams(props.parameters);
    }

    if (!props.title && props.match.params.pstId) {
      props.get(props.match.params.pstId);

      // throw and error for no ID
    } else if (!props.title && !props.match.params.pstId) {
      return (window.location = API.STATUS["4xx"]);

      // update the filters if they need to be updated
    } else if (mod && checkMod(mod, prevMod)) {
      props.modifyFilters(mod.modified);
      props.modifyParts(
        mod.compare,
        mod.sorted,
        mod.filters.reduce((a, b) => Object.assign({}, a, b), {}),
        mod.selected,
        props.ignoredBlanks,
        mod.andToggle,
        mod.s3Type
      );
      props.modifyQS(mod.qs);
    }
  }, [props.parameters, props.title, params, mod]);

  if (!props.title || !params)
    return (
      <div className="loading">
        <img
          className="rotate"
          width="40"
          height="40"
          src={PageLoadingIcon}
          key="pageLoading"
          alt={"Loader"}
        />
      </div>
    );

  // update the mod if it needs to be updated
  let values = determineFilters(props.parameters);
  if (checkMod(values, mod)) setMod(values);

  return (
    <div className={ classNames }>
      <PromoBanner />
      { 
        ( isDesktop || isTablet )
          ? <BreadCrumb /> 
          : null
      }
      <Title />
      {
        ( isDesktop || isTablet )
          ? <>
              <FeatureLayout mod={mod} setMod={setMod}/>
              <ManageTools />
              <Table />
              <PartPopup />
              {props.show && <ManageParametersModal />}
            </>
          : <>
              <FeatureMobileLayout mod={mod} setMod={setMod}/>
              <List />
            </>
      }
      <Pagination />
      
      <QualtricsFeedbackForm />
    </div>
  );
}

Layout.defaultProps = {
  ignoredBlanks: [],
};

Layout.propTypes = {
  get: PropTypes.func.isRequired,
  ignoredBlanks: PropTypes.array,
  modifyFilters: PropTypes.func.isRequired,
  modifyParts: PropTypes.func.isRequired,
  modifyQS: PropTypes.func.isRequired,
  title: PropTypes.string,
};

const mapStateToProps = (state) => ({
  parameters: state.filters.allParameters,
  ignoredBlanks: state.filters.ignoredBlanks,
  title: state.app.title,
  show: state.tools.showParameters,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ get, modifyFilters, modifyParts, modifyQS }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));